export default "__VITE_ASSET__DnZAv0v8__"